import { Denounced } from "../Model/Denounced";
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { Third } from "../Model/Third";
import { Query } from "../Model/Query";
export class DenouncedService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(denouncedId, diligenceId) {
        if (denouncedId) {
            const response = await this.apiService.get('denounced/' + diligenceId + '/third_id/' + denouncedId);
            if (!response.ok) {
                throw new Error(`Error al obtener al agresor`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener DenouncedId`);
        }
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('denounced/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener la victima`);
            }
            const content = await response.json();
            return content;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findLostThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`denounced_lost/lostThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveDenounced(denounded) {
        if (denounded) {
            const response = await this.apiService.post('denounced', denounded);
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciado.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener denunciado.`);
        }
    }
    async createDenounced(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const dateNow = new Date();
            const complainant = new Denounced({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                denouncedThirId: thirdId,
                manifestation: " ",
                dateCreated: dateNow.toString(),
                collegiate: null,
                present: " ",
                delivery: " ",
                userId: getCurrentUser().id,
                representativeThirdId: null,
                third_name: null
            });
            const response = await this.apiService.post('denounced', complainant.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante Global de una diligencia`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante Global`);
        }
    }
    async deleteDenouncedGlobal(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('denounced/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciado.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciado.`);
        }
    }
}
